// How the Pre-IFR Agent page words a job card. The statuses are decided by the API (apps/api/pre_ifr_view.py).

// "Sent 3:30 pm", "Due Today, 4:00 pm", "Failed", "—": the first message in a few words.
export function firstMessageText(first, formatWhen) {
  if (!first) return "—";
  switch (first.state) {
    case "sent":
      return `Sent ${formatWhen(first.sent_at)}`;
    case "pending":
      return `Due ${formatWhen(first.send_at)}`;
    case "failed":
      return "Failed";
    case "skipped":
      return "Not sent";
    default:
      return "—";
  }
}

export const stageText = (stage) => (stage || "").replace(/_/g, " ");
